import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 640,
  height: 960,
  x: 0,
  y: 0,
  list: [
    {
      id: '94121601-9e6e-4744-a720-3484dc7b15b9',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: 'bf22e0a5-f3bf-4b6c-a7d7-a0bbb2d81241',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_popup',
      parent: '94121601-9e6e-4744-a720-3484dc7b15b9',
      data: ''
    },
    {
      id: 'abc0cec8-c740-4359-a2ec-9b7938096a5f',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 249,
      y: -216,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'btn_close',
      parent: '94121601-9e6e-4744-a720-3484dc7b15b9',
      data: ''
    },
    {
      id: 'dab9abd7-ea3e-4da4-ac4f-3cb41a68abd2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -25,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'my_farm_premium_bg',
      parent: '94121601-9e6e-4744-a720-3484dc7b15b9',
      data: ''
    },
    {
      id: '8d13120d-5dce-4dea-8e91-027c11bb2277',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -222,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'PurchaseItem',
      localize: true,
      maxWidth: 420,
      maxHeight: 78,
      maxFontSize: 55,
      icons: [],
      style: {
        fontSize: 55,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#a9593e',
        strokeThickness: 7,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 0.9,
        dropShadowAngle: 1.8,
        dropShadowBlur: 0,
        dropShadowColor: '#b83500',
        dropShadowDistance: 3,
        leading: -15,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '94121601-9e6e-4744-a720-3484dc7b15b9',
      data: ''
    },
    {
      id: 'd54a1064-2e5e-4a68-8026-2831e8c8f1d0',
      type: 'Sprite',
      name: 'buyButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 179,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.900344,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_medium_green',
      parent: '94121601-9e6e-4744-a720-3484dc7b15b9',
      data: ''
    },
    {
      id: '3bcde55c-6266-487b-a5f5-428785490605',
      type: 'Container',
      name: 'dbContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'dab9abd7-ea3e-4da4-ac4f-3cb41a68abd2',
      data: ''
    },
    {
      id: '0ff39a08-c64b-4c9e-82bf-00f43874bb37',
      type: 'Sprite',
      name: 'loadingIcon',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.5,
        y: 1.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'loading_farm_icon',
      parent: 'dab9abd7-ea3e-4da4-ac4f-3cb41a68abd2',
      data: ''
    },
    {
      id: '32ae1b58-cfa7-4b22-b614-bc89fe15203a',
      type: 'Text',
      name: 'itemPrice',
      nameSpace: '',
      className: '',
      x: 0,
      y: -2,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 0,99',
      localize: false,
      maxWidth: 204,
      maxHeight: 82,
      maxFontSize: 51,
      icons: [],
      style: {
        fontSize: 51,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#277617',
        strokeThickness: 6,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'd54a1064-2e5e-4a68-8026-2831e8c8f1d0',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class PremiumItemPurchasePopupLayout {
  static raw = raw;
  root: PIXI.Container
  closeButton: PIXI.Sprite
  dbContainer: PIXI.Container
  loadingIcon: PIXI.Sprite
  buyButton: PIXI.Sprite
  itemPrice: PIXI.Text

  constructor() {
    populate(this, raw);
  }
}
